function PuppyAgreement() {
  return (
    <div className="app-puppy-agreement">
      <details>
        <summary>Cost and Shipping</summary>
        <p>
          All of our puppies are $2,800. Sorry we will not reduce the price of our puppies! We don't want to be "rid" of them. We have wonderful puppies that have been loved every moment of their lives, I owe it to them to find them families that will cherish them as we do.
        </p>

        <p>
          We've decided we will no longer fly our puppies. We have a friend and fellow poodle owner who is willing to drive puppies to their new home. I will be happy to provide contact information to make arrangements if interested.
        </p>
      </details>

      <details>
        <summary>Health Guarantee</summary>
        <p>
          I do not have a big, complicated contract. What I have is 28 years experience and 7 generations of wonderful, healthy poodles and their puppies. We have no hereditary illness (we would not breed anyone who is not in excellent health). Our puppy families keep in touch, many of which have adopted 3-4 pups from us over the years, and inform us of any issues (rare) and sadly of the day we all dread. This family history is <em>way</em> more valuable than any test that tells you if that dog has that illness at that time, not if they will get it in the future or pass it on. These tests are valuable only to breeders who do not build on the dogs they breed but rehome them and get new ones they know nothing about. The testing is to make the buyer feel safe but actually reveals nothing. Health history is as reliable as it gets.
        </p>

        <p>
          In the event one of our puppies has a hereditary illness (diagnosed and confirmed by your vet and mine) before two years of age, I will credit the purchase price of that puppy toward another available or future puppy of ours.
        </p>

        <p>
          I reserve the right to reclaim the ill puppy depending on the illness, situation and our conversations. I will not be responsible for vet bills or travel expenses. We take every precaution to ensure our pets produce healthy, long-lived babies, including genetic testing. Our goal is to give you a best friend to enjoy for years and years, not break your heart with a sick pet.
        </p>
      </details>

      <details>
        <summary>Spay/Neuter Agreement and Registration</summary>
        <p>
          If you are purchasing a puppy from us, you must agree to have the puppy spayed or neutered before it reaches 1 year of age. You will receive AKC registration papers at the time you provide proof the surgery has been done.
        </p>
      </details>

      <details>
        <summary>References</summary>
        <p>
          I used to post references, testimonials and much more on my <a href="https://pamperedpoodles4ublog.com/" target="_blank" rel="noopener noreferrer">blog</a> but we've since moved all our news and updates to <a href="https://www.facebook.com/125192348492/" target="_blank" rel="noopener noreferrer">FaceBook</a> where we have an active community of people who have, know, and love our babies.
        </p>
      </details>
    </div>
  );
}

export default PuppyAgreement;
